import React from "react";
import SidePanel from "../../../../../shared-components/css-modules/toyota/organisms/SidePanel";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { HighlightFeatureModalType } from "../../../../utils/modalConstants";
import Text from "../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "./HighlightFeatureModal.module.scss";

const HighlightFeatureModal = (props: ModalViewType<HighlightFeatureModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const { gradeFeature } = modalSettings;

    return (
        <SidePanel open={show} onRequestClose={close}>
            {!!gradeFeature && (
                <div className={styles.wrapper}>
                    {gradeFeature.assets[0]?.url && <img src={gradeFeature.assets[0].url} alt="" />}
                    {gradeFeature.learnMore && (
                        <Text variant="apheleia-body">
                            <span dangerouslySetInnerHTML={{ __html: gradeFeature.learnMore }} />
                        </Text>
                    )}
                </div>
            )}
        </SidePanel>
    );
};

export default HighlightFeatureModal;
